import { LightningColorArray, LightningSearchTypeEnum } from "@/util/cosntants";
import { IGetLocationsResModel } from "@/util/http/Lightning/responseType";

export const handleLocationSearchRequest = (locationNameOrCoordinate: string, selectedLocationItem?:IGetLocationsResModel ):[number,number]=>{
    // 正则匹配类似 "0,0" 或 "1,2" 的纯数字字符串
    const trimmed = locationNameOrCoordinate.trim();
    const match = trimmed.match(/^(-?\d+\.?\d*),\s*(-?\d+\.?\d*)$/);
    let tmpLng = 0;
    let tmpLat = 0;

    if (match) {
        tmpLat = parseFloat(match[1]);
        tmpLng = parseFloat(match[2]);
    }

    // 否则返回原字符串
    else if(selectedLocationItem ){
        tmpLat = selectedLocationItem?.latitude;
        tmpLng = selectedLocationItem?.longitude;
    }
    return [tmpLng, tmpLat];
};

export interface LatLng {
  lat: number;
  lng: number;
}

/**
 * 根据中心点、半径和点的数量，计算圆周上均匀分布的坐标点。
 * @param centerLat 圆心纬度
 * @param centerLng 圆心经度
 * @param radiusKm 圆的半径，单位为千米
 * @param numberOfPoints 要生成的点的数量，默认为12
 * @returns 包含圆周上坐标点的数组
 */
export const getPointsOnCircle = (
    centerLat: number,
    centerLng: number,
    radiusKm: number,
    numberOfPoints = 12
): LatLng[] => {
    const points: LatLng[] = [];
    const EARTH_RADIUS_KM = 6371; // 地球平均半径，单位：千米

    // 将中心点的经纬度转换为弧度
    const centerLatRad = (centerLat * Math.PI) / 180;
    const centerLngRad = (centerLng * Math.PI) / 180;

    // 计算每个点之间的角度间隔（弧度）
    const angleStep = (2 * Math.PI) / numberOfPoints;

    for (let i = 0; i < numberOfPoints; i++) {
        const angle = i * angleStep;

        // 计算相对于中心点的纬度变化量
        // dLat = (radius / EarthRadius) * cos(angle)
        const latDeltaRad = (radiusKm / EARTH_RADIUS_KM) * Math.cos(angle);

        // 计算相对于中心点的经度变化量
        // dLng = (radius / (EarthRadius * cos(centerLat))) * sin(angle)
        // 注意：这里的经度变化需要考虑纬度对圆周长度的影响
        const lngDeltaRad = (radiusKm / (EARTH_RADIUS_KM * Math.cos(centerLatRad))) * Math.sin(angle);

        // 计算新点的纬度（弧度）
        const newLatRad = centerLatRad + latDeltaRad;

        // 计算新点的经度（弧度）
        const newLngRad = centerLngRad + lngDeltaRad;

        // 将弧度转换回经纬度（度）
        const newLat = (newLatRad * 180) / Math.PI;
        const newLng = (newLngRad * 180) / Math.PI;

        points.push({ lat: newLat, lng: newLng });
    }

    return points;
};

// for color
export const firstStrikeTilteArray = [
    "0.00-10.00",
    "10.00-15.00",
    "15.00-20.00",
    "20.00-25.00",
    "25.00-30.00",
    "30.00-35.00",
    "35.00-40.00",
    "40.00-45.00",
    "45.00-50.00",
    "50.00-55.00",
    "55.00-60.00",
];
export const FIRST_STRIKE_COLORS = [
    { range: "0.00-10.00" , color: "#8B0000" },
    { range: "10.00-15.00", color: "#B22222" },
    { range: "15.00-20.00", color: "#CD5C5C" },
    { range: "20.00-25.00", color: "#FF6347" },
    { range: "25.00-30.00", color: "#FF8C00" },
    { range: "30.00-35.00", color: "#FFA500" },
    { range: "35.00-40.00", color: "#FFD700" },
    { range: "40.00-45.00", color: "#FFFF00" },
    { range: "45.00-50.00", color: "#ADFF2F" },
    { range: "50.00-55.00", color: "#7FFF00" },
    { range: "55.00-60.00", color: "#32CD32" },
];
export const PROBABILITY_COLORS = [
    { range: "0.05-0.10",color: "#C1E1C1" }, // 浅绿（加深）
    { range: "0.10-0.15",color: "#A9D18E" }, // 淡绿（加深）
    { range: "0.15-0.20",color: "#7CB342" }, // 中绿
    { range: "0.20-0.25",color: "#66BB6A" }, // 翠绿
    { range: "0.25-0.30",color: "#558B2F" }, // 深绿
    { range: "0.30-0.35",color: "#FFFF00" }, // 黄
    { range: "0.35-0.40",color: "#FFD740" }, // 浅橙黄（加深）
    { range: "0.40-0.45",color: "#FFC107" }, // 琥珀色
    { range: "0.45-0.50",color: "#FFA726" }, // 浅橙
    { range: "0.50-0.55",color: "#FF9800" }, // 橙
    { range: "0.55-0.60",color: "#FF7043" }, // 浅红橙
    { range: "0.60-0.65",color: "#FF5722" }, // 橙红
    { range: "0.65-0.70",color: "#F44336" }, // 红
    { range: "0.70-0.75",color: "#E53935" }, // 深红
    { range: "0.75-0.80",color: "#D32F2F" }, // 深暗红
    { range: "0.80-0.85",color: "#B71C1C" }, // 暗红
    { range: "0.85-0.90",color: "#990000" }, // 褐红
    { range: "0.90-0.95",color: "#7F0000" }, // 深褐红
    { range: "0.95-1.00", color: "#610B0B" }, // 近黑红
];

export const COLOR_ALL_RISK = LightningColorArray.Risk; // 例如：深红色
export const COLOR_RISK = "#FFC107"; // 例如：橙色

/**
 * 根据类型和字符串表示的范围获取对应的颜色。
 * @param type 'FirstStrike' | 'Probability'
 * @param valueStr 字符串形式的范围，例如 "0.05-0.10"
 * @returns 对应的颜色字符串，如果没有匹配则返回默认颜色 #CCCCCC
 */
export const getColorForValue = (type: LightningSearchTypeEnum.FIRSTSTRIKE | LightningSearchTypeEnum.PROBABILITY, valueStr: string): string => {
    const colorMap = type === LightningSearchTypeEnum.FIRSTSTRIKE ? FIRST_STRIKE_COLORS : PROBABILITY_COLORS;

    for (const { range, color } of colorMap) {
        if (range === valueStr) { // 直接字符串匹配
            return color;
        }
    }

    // 如果没有匹配的区间，返回一个默认颜色
    return "#CCCCCC"; // 灰色
};


// commone func
export const slefSleep = (ms: number) => {
    return new Promise(resolve => setTimeout(resolve, ms));
};
export const blockForOneSecond = async () => {
    await slefSleep(1000); // 模拟阻塞1秒
};

export const ProbilityArray = [
    "0.05-0.10",
    "0.10-0.15",
    "0.15-0.20",
    "0.20-0.25",
    "0.25-0.30",
    "0.30-0.35",
    "0.35-0.40",
    "0.40-0.45",
    "0.45-0.50",
    "0.50-0.55",
    "0.55-0.60",
    "0.60-0.65",
    "0.65-0.70",
    "0.70-0.75",
    "0.75-0.80",
    "0.80-0.85",
    "0.85-0.90",
    "0.90-0.95",
    "0.95-1.00",
];
export const ReversedProbabilityArray = [
    "0.95-1.00",
    "0.90-0.95",
    "0.85-0.90",
    "0.80-0.85",
    "0.75-0.80",
    "0.70-0.75",
    "0.65-0.70",
    "0.60-0.65",
    "0.55-0.60",
    "0.50-0.55",
    "0.45-0.50",
    "0.40-0.45",
    "0.35-0.40",
    "0.30-0.35",
    "0.25-0.30",
    "0.20-0.25",
    "0.15-0.20",
    "0.10-0.15",
    "0.05-0.10",
];